import { controller, target } from '@github/catalyst';
import type { Attachment } from '@github/file-attachment-element';
import { uploadAttachments } from '../attachments';
import { getLocale } from '../locale';

@controller('payer-file-upload')
export class PayerFileUploadElement extends HTMLElement {
  @target declare fileInput: HTMLInputElement;

  async fileAttachmentAccepted(
    event: CustomEvent<{ attachments: Attachment[] }>
  ) {
    const uploadHref = this.getAttribute('upload-href');
    if (!uploadHref) {
      throw new Error('Missing upload href');
    }
    const uploadUrl = new URL(uploadHref, location.origin);
    const payerFileId = crypto.randomUUID();
    uploadUrl.searchParams.set('owner_id', payerFileId);

    try {
      this.fileInput.disabled = true;
      this.fileInput.labels?.forEach(label => label.classList.add('btn-busy'));
      await uploadAttachments({
        locale: getLocale(),
        attachments: event.detail.attachments,
        uploadUrl,
        attachmentSaved: ({ id }) => {
          const { origin, pathname } = location;
          location.href = `${origin}${pathname}/new?payer_file_id=${encodeURIComponent(
            payerFileId
          )}&attachment_id=${encodeURIComponent(id!)}`;
        }
      });
    } finally {
      this.fileInput.disabled = false;
      this.fileInput.labels?.forEach(label =>
        label.classList.remove('btn-busy')
      );
    }
  }
}

declare global {
  interface Window {
    PayerFileUploadElement: typeof PayerFileUploadElement;
  }

  interface HTMLElementTagNameMap {
    'payer-file-upload': PayerFileUploadElement;
  }
}
